import * as FileSaver from 'file-saver';
import XLSX from 'sheetjs-style-v2';
import type { ViagemControle } from './types';
import { formatViagemCurrency } from './utils';

const formatDate = (value?: string | null) => {
  return value
    ? new Intl.DateTimeFormat('pt-BR', {
        dateStyle: 'short',
        timeStyle: 'short',
      }).format(new Date(value))
    : '';
};

const buildRows = (viagens: ViagemControle[]) =>
  viagens.map((viagem) => ({
    'ID viagem': viagem.idViagem || '',
    Shipment: viagem.shipment || '',
    Conhecimento: viagem.conhecimento || '',
    Viagem: viagem.viagem || '',
    Placa: viagem.placa || '',
    Agendamento: formatDate(viagem.agendamento),
    Chegada: formatDate(viagem.chegada),
    'Fim descarregamento': formatDate(viagem.fimDescarregamento),
    'Permanência REC': viagem.permanenciaRec || '',
    'Fim carregamento': formatDate(viagem.fimCarregamento),
    Saída: formatDate(viagem.saida),
    'Permanência EXP': viagem.permanenciaExp || '',
    'Total permanência': viagem.totalPermanencia || '',
    'Limite restante': viagem.limiteRestante || '',
    'Estadia pagar': viagem.estadiaPagar || '',
    'Valor estadia': formatViagemCurrency(viagem.valorEstadia, ''),
    Protocolo: viagem.approvalProtocol || '',
    Status: viagem.status || '',
    Aprovação: viagem.billingItem
      ? 'Faturada'
      : viagem.approvedAt
        ? 'Aprovado'
        : viagem.rejectedAt
          ? 'Rejeitado'
          : 'Pendente',
  }));

export const exportViagensControle = (viagens: ViagemControle[]) => {
  const worksheet = XLSX.utils.json_to_sheet(buildRows(viagens));
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Viagens');

  const buffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  FileSaver.saveAs(
    new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    }),
    `RELAT-VIAGENS-${new Date().getTime()}.xlsx`
  );
};
